<template>
	<!-- Main Wrapper -->
	<div class="main-wrapper login-body">
		<div class="sec_1">
			<img
				class="img-fluid logo-dark mb-2"
				src="@/assets/img/logo2.png"
				alt="Logo"
			/>
			<div style="margin-top: 30px">
				<!-- <h2 class="mt-3 mb-1">Email Verification</h2> -->
				<p class="message">
					Kindly check your email (<strong>{{ email }}</strong
					>) to verify your account with the verification link sent.
				</p>
				<p class="mt-4">
					Didn't receive a verification link?
					{{ `00:${time < 10 ? "0" + time : time}s` }}
					<button :disabled="time > 0" @click="resendLink" class="resend">
						Resend
					</button>
				</p>

				<router-link
					:to="{ name: 'login' }"
					class="btn btn-lg mt-4 btn-block btn-primary w-50"
				>
					Proceed
				</router-link>
			</div>
		</div>
	</div>
	<!-- /Main Wrapper -->
</template>

<script setup>
	import { ref, onMounted, onUnmounted } from "vue";
	import { useStore } from "vuex";

	const store = useStore();
	const email = localStorage.getItem("email");
	const time = ref(30);

	const resendLink = () => {
		time.value = 60;
		updateCountdown();
		store.dispatch("auth/resendlink");
	};

	const updateCountdown = () => {
		if (time.value > 0) {
			setTimeout(() => {
				time.value--;
				updateCountdown();
			}, 1000);
		}
	};

	onMounted(() => {
		updateCountdown();
	});

	onUnmounted(() => {
		localStorage.clear();
	});
</script>

<style scoped>
	.sec_1 {
		margin-top: 100px;
		display: flex;
		flex-direction: column;
		text-align: center;
		align-items: center;
		justify-content: center;
		padding: 0 20px;
	}

	.message {
		width: 85%;
		margin: 0 auto;
	}

	.resend {
		color: #3865b0;
		border: none;
		background-color: transparent;
	}

	.resend:disabled {
		color: grey;
	}

	@media (max-width: 960px) {
		.sec_1 {
			margin-top: 150px;
		}
	}
</style>
